import { useGetNewWagersQuery } from '@bo-services/members/newWagersApi';

export const useMemberEntryDetails = ({
  entryId,
  memberId
}: {
  entryId: string;
  memberId: string;
}) => {
  const {
    data: { data = [] } = {},
    isError,
    isLoading
  } = useGetNewWagersQuery(
    {
      id: entryId,
      userId: memberId
    },
    { skip: !entryId || !memberId }
  );

  return {
    newWager: data.length ? data[0] : undefined,
    isError,
    isLoading
  };
};
